import { render, staticRenderFns } from "./MacroItem.vue?vue&type=template&id=c0973dae&scoped=true&"
import script from "./MacroItem.vue?vue&type=script&lang=js&"
export * from "./MacroItem.vue?vue&type=script&lang=js&"
import style0 from "./MacroItem.vue?vue&type=style&index=0&id=c0973dae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0973dae",
  null
  
)

export default component.exports